{
  "partner": {
    "common": {
      "refresh": "Frissítés",
      "loadError": "Az adatok betöltése nem sikerült.",
      "retry": "Újrapróbálkozás",
      "adminOnlyTitle": "Csak partner-adminoknak"
    },
    "settings": {
      "adminOnlyDescription": "A beállítások a partner-adminok számára vannak fenntartva.",
      "tabs": {
        "users": "Felhasználókezelés"
      }
    },
    "team": {
      "inviteSuccess": "Meghívó elküldve",
      "inviteError": "A meghívót nem sikerült elküldeni.",
      "activateSales": {
        "action": "Aktiválás értékesítéshez",
        "successCreated": "HubSpot-kapcsolat létrehozva és összekapcsolva – a felhasználó mostantól küldhet leadeket.",
        "successLinked": "Összekapcsolva a HubSpot-kapcsolattal – a felhasználó mostantól küldhet leadeket.",
        "error": "Az értékesítési aktiválás sikertelen (hiányzó HubSpot írási jogosultság?)."
      },
      "adminOnlyDescription": "A felhasználókezelés a partner-adminok számára van fenntartva.",
      "membersTitle": "Bliks-felhasználók",
      "membersEmpty": "Még nincsenek felhasználók.",
      "columns": {
        "name": "Név",
        "email": "E-mail",
        "role": "Szerepkör",
        "status": "Státusz",
        "position": "Pozíció",
        "salesStatus": "Értékesítési státusz"
      },
      "salesStatus": {
        "active": "Értékesítésre aktiválva",
        "inactive": "Nincs aktiválva"
      },
      "addMember": "Tag hozzáadása",
      "dialog": {
        "createTitle": "Tag meghívása",
        "editTitle": "Tag szerkesztése",
        "description": "A csapattag neve, e-mailje és szerepköre.",
        "submitCreate": "Meghívás"
      },
      "createSuccess": "Meghívó elküldve",
      "createError": "A tag létrehozása nem sikerült.",
      "updateSuccess": "Módosítások mentve",
      "updateError": "A módosítások mentése nem sikerült.",
      "suspendSuccess": "Tag felfüggesztve",
      "unsuspendSuccess": "Tag visszaállítva",
      "deleteSuccess": "Tag eltávolítva",
      "deleteTitle": "Tag eltávolítása",
      "deleteDescription": "Ez a tag véglegesen eltávolításra kerül a partnerfiókból."
    },
    "home": {
      "title": "Kezdőlap",
      "greeting": "Üdv újra, {{name}}",
      "greetingAnonymous": "Üdv újra",
      "subtitle": "Hírek a BLIKS IO-tól és minden, amire az értékesítéshez szüksége van.",
      "quickLinks": "Gyors elérés",
      "links": {
        "sales": {
          "title": "Értékesítés",
          "description": "Leadek, kapcsolatlista és pipeline az értékesítési appban."
        },
        "infoHub": {
          "title": "Info Hub",
          "description": "Anyagok és videók az ügyfélbeszélgetésekhez."
        }
      },
      "news": {
        "title": "Hírek",
        "empty": "Jelenleg nincsenek hírek.",
        "error": "A híreket nem sikerült betölteni.",
        "pinned": "Kitűzve",
        "storyLabel": "Körhinta",
        "goTo": "{{index}}. hír / {{count}}"
      },
      "recentMaterial": {
        "title": "Új az Info Hubban",
        "all": "Összes anyag"
      }
    },
    "infoHub": {
      "title": "Info Hub",
      "subtitle": "Anyagok és videók a BLIKS IO-tól az értékesítéshez.",
      "language": "Nyelv",
      "searchLanguage": "Nyelv keresése …",
      "noLanguage": "Nincs ilyen nyelv.",
      "search": "Anyagok keresése …",
      "category": "Kategória",
      "categories": {
        "salesDocuments": "Értékesítési anyagok",
        "presentations": "Prezentációk",
        "caseStudies": "Esettanulmányok",
        "productInfo": "Termékinformációk"
      },
      "tabs": {
        "files": "Fájlok ({{count}})",
        "videos": "Videók ({{count}})"
      },
      "columns": {
        "title": "Anyag",
        "languages": "Nyelvek",
        "format": "Formátum"
      },
      "new": "Új",
      "download": "Letöltés",
      "downloadTitle": "„{{title}}” letöltése ezen a nyelven: {{language}}",
      "otherLanguages": "„{{title}}” letöltése más nyelven",
      "downloadIn": "Letöltés ezen a nyelven",
      "downloadFailed": "A letöltést nem sikerült elindítani.",
      "fallbackHint": "{{wanted}} nyelven nem érhető el, a(z) {{language}} változatot kapja.",
      "playVideo": "„{{title}}” videó lejátszása",
      "empty": "Még nincsenek anyagok.",
      "noVideos": "Még nincsenek videók.",
      "errorTitle": "Az Info Hub nem érhető el",
      "errorDescription": "Az anyagokat nem sikerült betölteni.",
      "availableIn": "Elérhető nyelvek: {{languages}}",
      "moreLanguages": "+{{count}}"
    },
    "tasks": {
      "title": "Feladatok",
      "subtitle": "Amit Önre bíztak, és még nyitott"
    }
  }
}
